import React from "react";
import PropTypes from "prop-types";

import formatPublishedDate from "utils/formatPublishedDate";
import { MicrodataContext } from "config/contexts";

import styles from "./PubDate.css";

export default function PubDate({ story }) {
  return (
    <MicrodataContext.Consumer>
      {microdata => (
        <time
          className={styles.root}
          itemProp={microdata ? "dateModified" : undefined}
          title={formatPublishedDate(story, true)}
          dateTime={story.published_date}
        >
          {formatPublishedDate(story)}
        </time>
      )}
    </MicrodataContext.Consumer>
  );
}

PubDate.propTypes = {
  story: PropTypes.shape({
    first_published: PropTypes.string,
    published_date: PropTypes.string,
    status: PropTypes.string,
  }).isRequired,
};
